<template>
  <div class="Protect-policy-home-main" :class="{ 'Protect-policy-home-main-mobile': isMobile}">
    <Base-title title="隐私政策"></Base-title>
    <PolicyContent></PolicyContent>
  </div>
</template>
<script>
  export default {
    // 隐私政策
    name: 'ProtectPolicyHome'
  };
</script>
<style lang="scss" scoped>
  .Protect-policy-home-main {
    display: flex;
    align-items: center;
    padding-top: 0.91rem;
    width: 100%;
    height: 7.56rem;
    flex-direction: column;
  }
  .Protect-policy-home-main-mobile {
    padding-top: 2.1rem;
    height: 27.7rem;
  }
</style>
